module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/page6-sponsor2.15b96931.png";